export default __webpack_public_path__ + "static/dx-problems-11898277f4c96f930f7a23323ccb16bf.png";